import React, { useState } from "react";
import { Container, Row, Col, Card, Carousel, Modal, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import profileImg from "../../Assets/IMG_6026.jpg";
import Particle from "../Particle";
import Type from "./Type";
import HexagonGroup from "../HexagonGroup";
import VideoPlayer from "../VideoPlayer";
import VideoThumbnail from "../VideoThumbnail";
import { projects } from "../../data/projects";
import { getMediaUrl, getBackgroundUrl } from "../../utils/mediaUtils";
import {
  FaHome,
  FaBuilding,
  FaTheaterMasks,
  FaCalendarAlt,
  FaArrowRight,
  FaEnvelope,
  FaEye,
  FaLightbulb,
  FaHeart,
  FaPalette,
  FaMapMarkerAlt,
  FaCalendar,
  FaRuler,
  FaTimes,
  FaPlay,
  FaImage,
  FaChevronLeft,
  FaChevronRight
} from "react-icons/fa";

// Composant pour la vue plein écran avec zoom (copié depuis Realizations.js)
function FullscreenMediaViewer({ project, activeIndex, onClose, onNavigate }) {
  React.useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        onClose();
      } else if (e.key === 'ArrowLeft') {
        const newIndex = activeIndex > 0 ? activeIndex - 1 : project.media.length - 1;
        onNavigate(newIndex);
      } else if (e.key === 'ArrowRight') {
        const newIndex = activeIndex < project.media.length - 1 ? activeIndex + 1 : 0;
        onNavigate(newIndex);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [activeIndex, project.media.length, onClose, onNavigate]);

  if (!project || !project.media || !project.media[activeIndex]) return null;

  const currentMedia = project.media[activeIndex];

  return (
    <div 
      className="fullscreen-viewer"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'zoom-out'
      }}
      onClick={onClose}
    >
      {/* Bouton fermer */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(255, 255, 255, 0.2)',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          color: 'white',
          fontSize: '1.5em',
          cursor: 'pointer',
          zIndex: 2001,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        }}
      >
        <FaTimes />
      </button>

      {/* Navigation gauche - Zone clicable minimale */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          const newIndex = activeIndex > 0 ? activeIndex - 1 : project.media.length - 1;
          onNavigate(newIndex);
        }}
          style={{
            position: 'absolute',
            left: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '40px', // Encore plus petit
            height: '40px', // Encore plus petit
            color: 'white',
            fontSize: '1em',
            cursor: 'pointer',
            zIndex: 500, // Très bas pour ne pas interférer
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0', // Pas de padding pour zone minimale
            margin: '0'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
            e.target.style.transform = 'translateY(-50%) scale(1.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
            e.target.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          <FaChevronLeft />
        </button>

      {/* Navigation droite - Zone clicable minimale */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          const newIndex = activeIndex < project.media.length - 1 ? activeIndex + 1 : 0;
          onNavigate(newIndex);
        }}
          style={{
            position: 'absolute',
            right: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '40px', // Encore plus petit
            height: '40px', // Encore plus petit
            color: 'white',
            fontSize: '1em',
            cursor: 'pointer',
            zIndex: 500, // Très bas pour ne pas interférer
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0', // Pas de padding pour zone minimale
            margin: '0'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
            e.target.style.transform = 'translateY(-50%) scale(1.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
            e.target.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          <FaChevronRight />
        </button>

      {/* Média principal */}
      <div
        onClick={(e) => {
          // Seulement empêcher la propagation si ce n'est pas une vidéo
          if (currentMedia.type !== 'video') {
            e.stopPropagation();
          }
        }}
        style={{
          maxWidth: '90vw',
          maxHeight: '90vh',
          background: currentMedia.type === 'image' ? getBackgroundUrl(currentMedia) : 'transparent',
          borderRadius: '10px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '60vw',
          minHeight: '60vh',
          cursor: currentMedia.type === 'video' ? 'default' : 'default'
        }}
      >
        {/* Icône type de média */}
        <div style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          color: "white",
          padding: "10px 15px",
          borderRadius: "25px",
          fontSize: "1em"
        }}>
          {currentMedia.type === "video" ? (
            <><FaPlay style={{ marginRight: "8px" }} /> Vidéo</>
          ) : (
            <><FaImage style={{ marginRight: "8px" }} /> Photo</>
          )}
        </div>





        {/* Contenu média */}
        {currentMedia.type === 'video' ? (
          <VideoPlayer
            src={getMediaUrl(currentMedia)}
            style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '10px' }}
            controls={true}
            autoPlay={false}
            showPlayButton={true}
            context="fullscreen"
          />
        ) : null}
      </div>

      {/* Caption unifié pour images et vidéos - Pass-through */}
      {currentMedia.caption && (
        <div style={{
          position: 'absolute',
          bottom: '40px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          color: 'white',
          padding: '15px 25px',
          borderRadius: '25px',
          fontSize: '1.1em',
          maxWidth: '80vw',
          textAlign: 'center',
          pointerEvents: 'none', // PASS-THROUGH: permet les clics de passer à travers
          zIndex: 100 // Bas pour ne pas interférer
        }}>
          {currentMedia.caption}
        </div>
      )}
    </div>
  );
}

// Modal de détail avec carousel et navigation entre projets (structure identique à Realizations.js)
function ProjectModal({ project, onClose, onNavigateProject, projectIndex, totalProjects }) {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [isFullscreen, setIsFullscreen] = React.useState(false);
  
  // Réinitialiser l'index quand un nouveau projet est sélectionné
  React.useEffect(() => {
    setActiveIndex(0);
  }, [project]);
  
  if (!project) return null;

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };

  const handleMediaClick = () => {
    setIsFullscreen(true);
  };

  const handleFullscreenClose = () => {
    setIsFullscreen(false);
  };

  const handleFullscreenNavigate = (newIndex) => {
    setActiveIndex(newIndex);
  };

  return (
    <>
      <Modal
        show={!!project}
        onHide={onClose}
        size="xl"
        centered
        style={{ zIndex: 1050 }}
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "var(--light-beige)",
            borderBottom: "1px solid var(--warm-beige)",
            position: 'relative'
          }}
        >
          <Modal.Title style={{ color: "var(--dark-brown)", fontSize: "1.8em" }}>
            {project.title}
          </Modal.Title>
          
          {/* Navigation entre projets */}
          {onNavigateProject && (
            <div style={{
              position: 'absolute',
              right: '60px',
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              gap: '10px'
            }}>
              {projectIndex > 0 && (
                <button
                  onClick={() => onNavigateProject(projectIndex - 1)}
                  style={{
                    background: 'var(--medium-brown)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '35px',
                    height: '35px',
                    color: 'white',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'var(--dark-brown)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'var(--medium-brown)';
                  }}
                  title="Projet précédent"
                >
                  <FaChevronLeft />
                </button>
              )}
              
              <span style={{
                color: 'var(--medium-brown)',
                fontSize: '0.9em',
                alignSelf: 'center',
                minWidth: '40px',
                textAlign: 'center'
              }}>
                {projectIndex + 1}/{totalProjects}
              </span>
              
              {projectIndex < totalProjects - 1 && (
                <button
                  onClick={() => onNavigateProject(projectIndex + 1)}
                  style={{
                    background: 'var(--medium-brown)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '35px',
                    height: '35px',
                    color: 'white',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'var(--dark-brown)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'var(--medium-brown)';
                  }}
                  title="Projet suivant"
                >
                  <FaChevronRight />
                </button>
              )}
            </div>
          )}
        </Modal.Header>

      <Modal.Body style={{ backgroundColor: "var(--light-beige)", padding: "0" }}>
        <Row style={{ margin: "0" }}>
          {/* Carousel Section */}
          <Col md={7} style={{ padding: "0" }}>
            {project.media && project.media.length > 0 && (
              <div>
                <Carousel
                  activeIndex={activeIndex}
                  onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                  interval={null}
                  indicators={false}
                  controls={true}
                  style={{ borderRadius: "0" }}
                >
                  {project.media.map((media, index) => (
                    <Carousel.Item key={index}>
                      <div 
                        style={{
                          height: "400px",
                          background: media.type === 'image' ? media.url : 'var(--light-beige)',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                          cursor: "zoom-in"
                        }}
                        onClick={handleMediaClick}
                      >
                        {/* Icône pour différencier image/vidéo */}
                        <div style={{
                          position: "absolute",
                          top: "20px",
                          right: "20px",
                          backgroundColor: "rgba(0, 0, 0, 0.6)",
                          color: "white",
                          padding: "8px 12px",
                          borderRadius: "20px",
                          fontSize: "0.9em"
                        }}>
                          {media.type === "video" ? (
                            <><FaPlay style={{ marginRight: "5px" }} /> Vidéo</>
                          ) : (
                            <><FaImage style={{ marginRight: "5px" }} /> Photo</>
                          )}
                        </div>

                        {/* Media content */}
                        {media.type === "video" ? (
                          <VideoPlayer
                            src={getMediaUrl(media)}
                            style={{ 
                              width: "100%", 
                              height: "400px", 
                              objectFit: "cover",
                              borderRadius: "10px" 
                            }}
                            controls={true}
                            preload="metadata"
                            onClick={(e) => e.stopPropagation()}
                            showPlayButton={true}
                            context="carousel"
                          />
                        ) : (
                          // For images, we keep CSS background already set via media.url
                          <div
                            aria-hidden
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          />
                        )}
                      </div>
                      {/* Caption unifié pour images et vidéos */}
                      {media.caption && (
                        <Carousel.Caption style={{
                          backgroundColor: "rgba(0, 0, 0, 0.7)",
                          borderRadius: "10px",
                          padding: "10px 15px"
                        }}>
                          <p style={{ margin: "0", fontSize: "1em" }}>{media.caption}</p>
                        </Carousel.Caption>
                      )}
                    </Carousel.Item>
                  ))}
                </Carousel>
                
                {/* Galerie de miniatures */}
                {project.media.length > 1 && (
                  <div style={{
                    padding: "15px",
                    backgroundColor: "rgba(245, 241, 232, 0.8)",
                    borderTop: "1px solid var(--warm-beige)"
                  }}>
                    <div style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      flexWrap: "wrap"
                    }}>
                      {project.media.map((media, index) => (
                        <div
                          key={index}
                          onClick={() => handleThumbnailClick(index)}
                          style={{
                            width: "60px",
                            height: "60px",
                            background: media.type === 'image' ? media.url : 'var(--light-beige)',
                            borderRadius: "8px",
                            cursor: "pointer",
                            border: activeIndex === index ? "3px solid var(--medium-brown)" : "2px solid rgba(255, 255, 255, 0.5)",
                            transition: "all 0.3s ease",
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: activeIndex === index ? 1 : 0.7,
                            overflow: "hidden"
                          }}
                          onMouseEnter={(e) => {
                            if (activeIndex !== index) {
                              e.target.style.opacity = "0.9";
                              e.target.style.transform = "scale(1.05)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeIndex !== index) {
                              e.target.style.opacity = "0.7";
                              e.target.style.transform = "scale(1)";
                            }
                          }}
                        >
                          {/* Video thumbnail */}
                          {media.type === 'video' && (
                            <VideoPlayer
                              src={getMediaUrl(media)}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                position: 'absolute',
                                top: 0,
                                left: 0
                              }}
                              controls={false}
                              muted={true}
                              preload="metadata"
                              showPlayButton={false}
                              context="thumbnail"
                            />
                          )}
                          
                          {/* Icône type de média sur la miniature */}
                          <div style={{
                            position: "absolute",
                            top: "2px",
                            right: "2px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            color: "white",
                            padding: "2px 4px",
                            borderRadius: "4px",
                            fontSize: "0.6em"
                          }}>
                            {media.type === "video" ? <FaPlay /> : <FaImage />}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </Col>

          {/* Details Section */}
          <Col md={5} style={{ padding: "30px" }}>
            <div style={{ marginBottom: "25px" }}>
              <Badge
                className="custom-badge"
                style={{
                  backgroundColor: "var(--medium-brown) !important",
                  color: "white !important",
                  fontSize: "0.9em",
                  marginBottom: "15px",
                  border: "none"
                }}
              >
                {project.category}
              </Badge>

              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                  <span style={{ color: "var(--secondary-text)" }}>
                    <FaMapMarkerAlt style={{ marginRight: "8px", color: "var(--medium-brown)" }} />
                    {project.location}
                  </span>
                  <span style={{ color: "var(--secondary-text)" }}>
                    <FaCalendar style={{ marginRight: "8px", color: "var(--medium-brown)" }} />
                    {project.year}
                  </span>
                </div>
                {project.surface && (
                  <div style={{ color: "var(--secondary-text)" }}>
                    <FaRuler style={{ marginRight: "8px", color: "var(--medium-brown)" }} />
                    {project.surface}
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: "25px" }}>
              <h5 style={{ color: "var(--dark-brown)", marginBottom: "15px" }}>Description</h5>
              <p style={{
                color: "var(--secondary-text)",
                lineHeight: "1.6",
                fontSize: "1em",
                whiteSpace: "pre-line"
              }}>
                {project.fullDescription}
              </p>
            </div>

            {project.details && (
              <div>
                <h5 style={{ color: "var(--dark-brown)", marginBottom: "15px" }}>Détails du projet</h5>

                <div style={{ marginBottom: "15px" }}>
                  <strong style={{ color: "var(--medium-brown)" }}>Client :</strong>
                  <span style={{ color: "var(--secondary-text)", marginLeft: "10px" }}>
                    {project.details.client}
                  </span>
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <strong style={{ color: "var(--medium-brown)" }}>Budget travaux :</strong>
                  <span style={{ color: "var(--secondary-text)", marginLeft: "10px" }}>
                    {project.details.budget}
                  </span>
                </div>

                {project.details.defis && (
                  <div style={{ marginBottom: "15px" }}>
                    <strong style={{ color: "var(--medium-brown)" }}>Défis relevés :</strong>
                    <ul style={{ color: "var(--secondary-text)", marginTop: "8px", paddingLeft: "20px" }}>
                      {project.details.defis.map((defi, index) => (
                        <li key={index} style={{ marginBottom: "5px" }}>{defi}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {project.details.materiaux && (
                  <div>
                    <strong style={{ color: "var(--medium-brown)" }}>Matériaux utilisés :</strong>
                    <ul style={{ color: "var(--secondary-text)", marginTop: "8px", paddingLeft: "20px" }}>
                      {project.details.materiaux.map((materiau, index) => (
                        <li key={index} style={{ marginBottom: "5px" }}>{materiau}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer style={{
        backgroundColor: "var(--light-beige)",
        borderTop: "1px solid var(--warm-beige)",
        justifyContent: "center"
      }}>
        <button
          onClick={onClose}
          style={{
            backgroundColor: "var(--medium-brown)",
            border: "none",
            padding: "10px 30px",
            borderRadius: "25px",
            fontSize: "1.1em",
            color: "white",
            cursor: "pointer"
          }}
        >
          <FaTimes style={{ marginRight: "8px" }} />
          Fermer
        </button>
      </Modal.Footer>
    </Modal>

    {/* Fullscreen Media Viewer */}
    {isFullscreen && (
      <FullscreenMediaViewer
        project={project}
        activeIndex={activeIndex}
        onClose={handleFullscreenClose}
        onNavigate={handleFullscreenNavigate}
      />
    )}
  </>
  );
}

function Home() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(0);

  const services = [
    {
      icon: <FaHome />,
      title: "Résidentiel",
      description: "Aménagement d'intérieur pour votre maison",
      color: "#8B7355"
    },
    {
      icon: <FaBuilding />,
      title: "Commercial", 
      description: "Espaces professionnels et boutiques",
      color: "#A0845C"
    },
    {
      icon: <FaTheaterMasks />,
      title: "Scénographie",
      description: "Créations artistiques et expositions",
      color: "#6B5B47"
    },
    {
      icon: <FaCalendarAlt />,
      title: "Événementiel",
      description: "Décoration pour vos événements",
      color: "#D4B896"
    }
  ];



  // Sélection des 3 projets les plus récents
  const fullProjects = projects
    .sort((a, b) => parseInt(b.year) - parseInt(a.year))
    .slice(0, 3);

  const portfolioHighlights = fullProjects.map(project => ({
    id: project.id,
    title: project.title,
    location: project.location,
    image: project.media[0].type === 'image' ? project.media[0].url : null,
    videoUrl: project.media[0].type === 'video' ? getMediaUrl(project.media[0]) : null,
    mediaType: project.media[0].type,
    category: project.category,
    gradient: project.gradient
  }));

  // Fonctions de navigation entre projets
  const handleProjectSelect = (project, index) => {
    setSelectedProject(project);
    setSelectedProjectIndex(index);
  };

  const handleProjectNavigation = (newIndex) => {
    if (newIndex >= 0 && newIndex < fullProjects.length) {
      setSelectedProject(fullProjects[newIndex]);
      setSelectedProjectIndex(newIndex);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container style={{ position: "relative", zIndex: 2 }}>
          <Row style={{ alignItems: "center", minHeight: "100vh", paddingTop: "100px" }}>
            <Col md={6}>
            
              <h1 style={{ fontSize: "3em", marginBottom: "30px", color: "var(--primary-text)" }}>
                Bienvenue sur mon{" "}
                <strong className="purple">site !</strong>
              </h1>

              <p style={{
                fontSize: "1.3em",
                color: "var(--secondary-text)",
                lineHeight: "1.7",
                marginBottom: "40px"
              }}>
                Découvrez mon univers, mon savoir-faire et mes projets. Bonne exploration !
              </p>

              <div style={{
                marginBottom: "30px",
                fontSize: "1.2em",
                color: "var(--medium-brown)",
                fontWeight: "500"
              }}>
                <span style={{ marginRight: "15px",fontSize: "1.5em", color: "var(--medium-brown)",fontWeight: "500"}}>Je suis votre future</span>
                <Type />
              </div>

            </Col>

            <Col md={6} style={{ textAlign: "center" }}>
              <div style={{ position: "relative" }}>
                <img
                  src={profileImg}
                  alt="MBL Designer"
                  className="img-fluid"
                  style={{ 
                    maxHeight: "600px",
                    borderRadius: "20px",
                    boxShadow: "0 20px 40px rgba(139, 115, 85, 0.3)"
                  }}
                />
                <div style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "20px",
                  backgroundColor: "rgba(139, 115, 85, 0.9)",
                  color: "white",
                  padding: "15px 20px",
                  borderRadius: "15px",
                  backdropFilter: "blur(10px)",
                  display: "none"
                }}>
                  <FaPalette style={{ marginRight: "10px" }} />
                  <strong>MBL Designer</strong>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      
      {/* Portfolio Highlights Carousel */}
      <Container fluid style={{ backgroundColor: "rgba(245, 241, 232, 0.3)", padding: "80px 0" }}>
        <Container>
          {/* Hexagones décoratifs avant la section projets */}
          <HexagonGroup position="right" />
          
          <Row>
            <Col md={12} style={{ textAlign: "center", marginBottom: "50px" }}>
              <h2 style={{ fontSize: "2.8em", color: "var(--primary-text)", marginBottom: "20px" }}>
                <strong className="purple">Projets les plus récents</strong>
              </h2>
              <p style={{ fontSize: "1.2em", color: "var(--secondary-text)", maxWidth: "600px", margin: "0 auto" }}>
                Découvrez mes dernières créations et réalisations
              </p>
            </Col>
          </Row>
          
          <Carousel 
            interval={4000} 
            indicators={true}
            controls={true}
            style={{ 
              borderRadius: "20px", 
              overflow: "hidden"
            }}
            className="custom-carousel-indicators"
          >
            {portfolioHighlights.map((project, index) => (
              <Carousel.Item key={index}>
                <div
                  style={{
                    height: "400px",
                    background: project.mediaType === 'image' ? project.image : `linear-gradient(135deg, ${project.gradient})`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    cursor: "pointer",
                    overflow: "hidden"
                  }}
                  onClick={() => {
                    const fullProject = fullProjects.find(p => p.id === project.id);
                    const projectIndex = fullProjects.findIndex(p => p.id === project.id);
                    handleProjectSelect(fullProject, projectIndex);
                  }}
                >
                  {/* Video thumbnail pour les projets vidéo */}
                  {project.mediaType === 'video' && (
                    <VideoThumbnail
                      src={project.videoUrl}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                      }}
                      fallbackGradient={project.gradient}
                      showPlayButton={false}
                    />
                  )}
                  <div style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    right: "0",
                    background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
                    color: "white",
                    padding: "40px",
                    textAlign: "left"
                  }}>
                    <h3 style={{ fontSize: "2.5em", marginBottom: "10px" }}>{project.title}</h3>
                    <p style={{ fontSize: "1.3em", marginBottom: "10px" }}>
                      <FaHome style={{ marginRight: "10px" }} />
                      {project.location}
                    </p>
                    <span style={{
                      backgroundColor: "rgba(139, 115, 85, 0.8)",
                      padding: "8px 15px",
                      borderRadius: "20px",
                      fontSize: "1em"
                    }}>
                      {project.category}
                    </span>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
          
          {/* Hexagones décoratifs après le carousel */}
          <HexagonGroup position="scattered" />
          
          <Row style={{ marginTop: "40px" }}>
            <Col md={12} style={{ textAlign: "center" }}>
              <button
                onClick={() => navigate('/realizations')}
                style={{
                  backgroundColor: "#8B7355",
                  color: "white",
                  border: "none",
                  padding: "15px 30px",
                  borderRadius: "25px",
                  fontSize: "1.2em",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#6B5B47";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#8B7355";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                <FaEye style={{ marginRight: "10px" }} />
                Voir Toutes les Réalisations
              </button>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Services Section */}
      <Container fluid style={{ padding: "80px 0" }}>
        <Container>
          <Row>
            <Col md={12} style={{ textAlign: "center", marginBottom: "50px" }}>
              <h2 style={{ fontSize: "2.8em", color: "var(--primary-text)", marginBottom: "20px" }}>
                <strong className="purple">Domaines d'Expertise</strong>
              </h2>
              <p style={{ fontSize: "1.2em", color: "var(--secondary-text)", maxWidth: "700px", margin: "0 auto" }}>
                De l'aménagement résidentiel à la scénographie, je vous accompagne dans tous vos projets
              </p>
              {/* Hexagones décoratifs dans la section services */}
              <HexagonGroup position="center" />
            </Col>
          </Row>
          <Row>
            {services.map((service, index) => (
              <Col md={6} lg={3} key={index} style={{ marginBottom: "30px" }}>
                <Card
                  style={{
                    height: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    border: "none",
                    borderRadius: "20px",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    boxShadow: "0 5px 15px rgba(139, 115, 85, 0.1)"
                  }}
                  onClick={() => navigate('/services')}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow = "0 15px 30px rgba(139, 115, 85, 0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 5px 15px rgba(139, 115, 85, 0.1)";
                  }}
                >
                  <Card.Body style={{ padding: "40px", textAlign: "center" }}>
                    <div style={{
                      fontSize: "4em",
                      color: service.color,
                      marginBottom: "25px",
                      transition: "all 0.3s ease"
                    }}>
                      {service.icon}
                    </div>
                    <h4 style={{
                      color: "var(--dark-brown)",
                      marginBottom: "20px",
                      fontSize: "1.4em",
                      fontWeight: "bold"
                    }}>
                      {service.title}
                    </h4>
                    <p style={{
                      color: "var(--secondary-text)",
                      fontSize: "1.1em",
                      lineHeight: "1.6"
                    }}>
                      {service.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={12} style={{ textAlign: "center", marginTop: "40px" }}>
              <button
                onClick={() => navigate('/services')}
                style={{
                  backgroundColor: "transparent",
                  border: "2px solid #8B7355",
                  color: "#8B7355",
                  padding: "15px 35px",
                  borderRadius: "25px",
                  fontSize: "1.2em",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#8B7355";
                  e.target.style.color = "white";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#8B7355";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Découvrir Toutes les Prestations <FaArrowRight style={{ marginLeft: "10px" }} />
              </button>
            </Col>
          </Row>
        </Container>
      </Container>


      {/* Call to Action Section */}
      <Container fluid style={{ backgroundColor: "rgba(139, 115, 85, 0.1)", padding: "100px 0" }}>
        <Container>
          <Row>
            <Col md={12} style={{ textAlign: "center" }}>
              <FaLightbulb style={{
                fontSize: "5em",
                color: "var(--medium-brown)",
                marginBottom: "30px"
              }} />
              <h2 style={{
                fontSize: "3em",
                color: "var(--primary-text)",
                marginBottom: "25px",
                fontWeight: "bold"
              }}>
                Prêt à donner vie à votre <strong className="purple">projet</strong> ?
              </h2>
              <p style={{
                fontSize: "1.3em",
                color: "var(--secondary-text)",
                maxWidth: "800px",
                margin: "0 auto 50px auto",
                lineHeight: "1.7"
              }}>
                Contactez-moi dès aujourd'hui pour un premier échange gratuit.
                Ensemble, nous créerons l'espace de vos rêves !
              </p>
              <div style={{ display: "flex", gap: "25px", justifyContent: "center", flexWrap: "wrap" }}>
                <button
                  onClick={() => navigate('/contact')}
                  style={{
                    backgroundColor: "#8B7355",
                    color: "white",
                    border: "none",
                    padding: "20px 40px",
                    borderRadius: "30px",
                    fontSize: "1.3em",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 8px 20px rgba(139, 115, 85, 0.3)"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#6B5B47";
                    e.target.style.transform = "translateY(-3px)";
                    e.target.style.boxShadow = "0 12px 25px rgba(139, 115, 85, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#8B7355";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 8px 20px rgba(139, 115, 85, 0.3)";
                  }}
                >
                  <FaEnvelope style={{ marginRight: "12px" }} />
                  Contactez-moi
                </button>
                <button
                  onClick={() => navigate('/about')}
                  style={{
                    backgroundColor: "transparent",
                    border: "3px solid #8B7355",
                    color: "#8B7355",
                    padding: "20px 40px",
                    borderRadius: "30px",
                    fontSize: "1.3em",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.3s ease"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#8B7355";
                    e.target.style.color = "white";
                    e.target.style.transform = "translateY(-3px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#8B7355";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <FaHeart style={{ marginRight: "12px" }} />
                  En savoir plus
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Modal */}
      <ProjectModal
        project={selectedProject}
        onClose={() => setSelectedProject(null)}
        onNavigateProject={handleProjectNavigation}
        projectIndex={selectedProjectIndex}
        totalProjects={fullProjects.length}
      />
    </div>
  );
}

export default Home;
